// extracted by mini-css-extract-plugin
var _1 = "#4c4c4c";
var _2 = "640px";
var _3 = "790px";
var _4 = "#057676";
var _5 = "#434343";
var _6 = "actionbutton_icon__0t1hy";
var _7 = "79px";
var _8 = "110px";
var _9 = "72px";
var _a = "665px";
var _b = "teal";
var _c = "2";
var _d = "#cdd3dc";
var _e = "actionbutton_wrapper__hervo";
export { _1 as "body", _2 as "controlsMobileWidth", _3 as "controlsStackedWidth", _4 as "darkTeal", _5 as "headline", _6 as "icon", _7 as "menuHeight", _8 as "menuHeightLarge", _9 as "menuHeightMobile", _a as "modalMobileWidth", _b as "teal", _c as "timelineStrokeWidth", _d as "timelineTrackColor", _e as "wrapper" }
